import React from "react";
import { CloseDialogContext } from "../common/DialogComponent";
import { useTranslation } from "react-i18next";

const PSSPopupDetails = () => {
    const { t: tLang } = useTranslation();

    const close: any = React.useContext(CloseDialogContext);

    const closeDialog = () => {
        close("alert-details-dialog");
    };

    return (
        <React.Fragment>
            <>
                <div className="dialog-header">
                    <div className="pss-dialog-header">
                        <h3>
                            Your Data Is Protected by Triple Layer Defense<sup>SM</sup>
                        </h3>
                        <p>
                            All your information is stored using the highest level of encryption from our Triple Layer Defense<sup>SM</sup> system. Our system has
                            been independently verified and is continuously audited to ensure our high standards of security.
                        </p>

                        <p>This means your information is encrypted in transit, in use and at rest.</p>
                        <p>Additionally, your stored data is...</p>
                        <ul>
                            <li>Encrypted at the system level in the cloud</li>
                            <li>Encrypted within your unique account </li>
                        </ul>
                        <p>
                            Be sure to take advantage of all your account features and keep your information up-to-date in your Online Identity Vault<sup>TM</sup>.
                        </p>
                    </div>
                </div>

                <div className="dialog-footer" style={{ paddingTop: "1.5rem" }}>
                    <div className="">
                        <div className="col-xs col-no-gutter flex-grow-null">
                            <button type="button" className="btn-default btn-link pss-dialog-button" onClick={() => closeDialog()}>
                                <span className="btn-text">{tLang("alerts.alerts.activeAlertPopup.buttonText.Close")}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </>
        </React.Fragment>
    );
};

export default PSSPopupDetails;
